import React, {useContext} from 'react'

import {apphistory} from '../../store'
import Button from '../../components/button/Button'
import InputFactory from './Fields/InputFactory'
import {IFormContentProps, IFormProps} from './FormProps'
import useFormLogic from './hooks/useFormLogic'
import {CurrentFormUrlPathContext} from '../../pages/AppRoot/hooks/useAppRootLogic'
import {TFieldsType} from '../../models/form/IFieldsDefinition'
import {AppButtonTypes} from '../button/ButtonProps'


import './Form.scss'
import AppButton from "../atoms/AppButton/AppButton";
import {UI_BUTTON_TYPE} from "../atoms/AppButton/AppButtonProps";
import PageHeader from "../atoms/PageHeader/PageHeader";
import {HEADER_LEVEL} from "../atoms/PageHeader/PageHeaderProps";


export const FormContent = (props: IFormContentProps) => {
    const {handleValidateSingleField} = useFormLogic()

    return (
        <>
            {
                props.formLabel ? <div className='form-label-wrapper'>
                    <PageHeader
                        title={props.formLabel}
                        level={HEADER_LEVEL.H2}
                        line={true}
                    />

                    </div>
                    : null
            }
            <div className='form-inner-wrapper'>
                {Object.values(props.fields)
                    .sort((a: TFieldsType, b: TFieldsType) => {
                        if (a.order && b.order) {
                            return a.order < b.order ? -1 : 1
                        } else return 0
                    })
                    .map((field: TFieldsType) => {
                        return (
                            <InputFactory
                                key={`${props.formName}-${field.name}`}
                                formName={props.formName}
                                fieldDefinition={field}
                                fieldState={props.fieldsState[field.name]}
                                handleValidateSingleField={handleValidateSingleField}
                                currentFieldValidation={field.name in props.formValidationFunctions ? props.formValidationFunctions[field.name as keyof typeof props.formValidationFunctions] : undefined}
                            />
                        )
                    })}
            </div>
        </>
    )
}


export const Form = (props: IFormProps) => {
    const {setCurrentUrlFormPath} = useContext(CurrentFormUrlPathContext)
    const {form, fields, formState, isFinalPage, children, onFormSubmit} = props

    return (
        <form id={form.name} className='form-outer-wrapper'>
            <FormContent
                fields={fields}
                formName={form.name}
                formLabel={form.label}
                fieldsState={formState.fieldsData}
                formValidationFunctions={form.formValidationFunctions}
            />

            {children ?? null} {/* Jeśli przekazaliśmy jakieś dzieci do komponentu, wyświetlamy je pomiędzy formularzem a przyciskiem */}


            <AppButton
                name="form-submit-button"
                uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault()
                    const currentForm = document.querySelector(`form[id='${form.name}']`) as HTMLFormElement
                    const formData = new FormData(currentForm)  //Tworzymy obiekt FormData dla obecnego formularza. Obiekt ten zawiera tablicę obiektów: {nazwaPola, wartośćPola} dla wszystkich nawet dodatkowych pól formularza

                    onFormSubmit(Object.fromEntries(formData.entries()))
                }}>
                {isFinalPage ? 'Złóż wniosek' : 'Dalej'}
            </AppButton>


            {
                (form.canStepBackInForm && form.previousFormUrlPath) && (
                    <Button
                        uiButtonType={AppButtonTypes.OUTLINED_SECONDARY}
                        buttonContent='Wróć'
                        onClick={() => {
                            if (form.previousFormUrlPath) {
                                setCurrentUrlFormPath(form.previousFormUrlPath)
                                apphistory.push(form.previousFormUrlPath)
                            }
                        }}
                    />
                )
            }
        </form>
    )
}

export default Form